"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _regeneratorRuntime = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es6.date.now");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockCacheService = void 0;

var minimatch_1 = require("minimatch");

var FeatureRoot_1 = require("../../root/FeatureRoot");

var CacheService_1 = require("../CacheService");

var StubErrorService_1 = require("../stub/StubErrorService");

var MockCacheService = /*#__PURE__*/function (_CacheService_1$Cache) {
  _inherits(MockCacheService, _CacheService_1$Cache);

  function MockCacheService(opts, root) {
    var _this;

    _classCallCheck(this, MockCacheService);

    if (root) {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(MockCacheService).call(this, opts, root));
    } else {
      var newRoot = new FeatureRoot_1.FeatureRoot({});
      newRoot.deps.services.setErrorService(new StubErrorService_1.StubErrorService(null));
      _this = _possibleConstructorReturn(this, _getPrototypeOf(MockCacheService).call(this, opts, newRoot));
    }

    _this.store = {};
    return _possibleConstructorReturn(_this);
  }

  _createClass(MockCacheService, [{
    key: "getStore",
    value: function getStore() {
      return 'mock';
    }
  }, {
    key: "parseEntryValue",
    value: function parseEntryValue(key, entry) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(entry && entry.expiresUnix && entry.expiresUnix <= Math.floor(Date.now()))) {
                  _context.next = 5;
                  break;
                }

                delete this.store[key];
                return _context.abrupt("return", null);

              case 5:
                return _context.abrupt("return", entry === null || entry === void 0 ? void 0 : entry.value);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "_clear",
    value: function _clear() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.store = {};

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "_get",
    value: function _get(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var entry;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                entry = this.store[key];

                if (!entry) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", this.parseEntryValue(key, entry));

              case 5:
                return _context3.abrupt("return", null);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "_put",
    value: function _put(key, value, secondsOrOpts) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var seconds, existing;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                seconds = typeof secondsOrOpts === 'number' ? secondsOrOpts : secondsOrOpts === null || secondsOrOpts === void 0 ? void 0 : secondsOrOpts.seconds;

                if (!(typeof secondsOrOpts !== 'number' && (secondsOrOpts === null || secondsOrOpts === void 0 ? void 0 : secondsOrOpts.ifNotExists))) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return this.parseEntryValue(key, this.store[key]);

              case 4:
                existing = _context4.sent;

                if (!(existing !== null && existing !== undefined)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", false);

              case 7:
                this.store[key] = {
                  value: value,
                  expiresUnix: seconds ? Math.floor(Date.now()) + seconds * 1000 : undefined
                };
                return _context4.abrupt("return", true);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "_delete",
    value: function _delete(keys) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context5.prev = 3;

                for (_iterator = keys[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  key = _step.value;
                  delete this.store[key];
                }

                _context5.next = 11;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context5.t0;

              case 11:
                _context5.prev = 11;
                _context5.prev = 12;

                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }

              case 14:
                _context5.prev = 14;

                if (!_didIteratorError) {
                  _context5.next = 17;
                  break;
                }

                throw _iteratorError;

              case 17:
                return _context5.finish(14);

              case 18:
                return _context5.finish(11);

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[3, 7, 11, 19], [12,, 14, 18]]);
      }));
    }
  }, {
    key: "_batchGetKeys",
    value: function _batchGetKeys(keys) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key, v;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                result = {};
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 4;
                _iterator2 = keys[Symbol.iterator]();

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context6.next = 16;
                  break;
                }

                key = _step2.value;

                if (!this.store[key]) {
                  _context6.next = 13;
                  break;
                }

                _context6.next = 11;
                return this.parseEntryValue(key, this.store[key]);

              case 11:
                v = _context6.sent;

                if (v !== null) {
                  result[key] = v;
                }

              case 13:
                _iteratorNormalCompletion2 = true;
                _context6.next = 6;
                break;

              case 16:
                _context6.next = 22;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6["catch"](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t0;

              case 22:
                _context6.prev = 22;
                _context6.prev = 23;

                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                  _iterator2["return"]();
                }

              case 25:
                _context6.prev = 25;

                if (!_didIteratorError2) {
                  _context6.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context6.finish(25);

              case 29:
                return _context6.finish(22);

              case 30:
                return _context6.abrupt("return", result);

              case 31:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 18, 22, 30], [23,, 25, 29]]);
      }));
    }
  }, {
    key: "batchGetKeysWithGlob",
    value: function batchGetKeysWithGlob(glob) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var mm, matchingKeys;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                mm = new minimatch_1.Minimatch(glob);
                matchingKeys = Object.keys(this.store).filter(function (key) {
                  return mm.match(key);
                });
                return _context7.abrupt("return", this.batchGetKeys(matchingKeys));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "_setAdd",
    value: function _setAdd(key, values, seconds) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var existing, lengthBefore;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                existing = ((_a = this.store[key]) === null || _a === void 0 ? void 0 : _a.value) || [];

                if (!Array.isArray(existing)) {
                  _context8.next = 7;
                  break;
                }

                lengthBefore = existing.length;
                this.store[key] = {
                  value: _toConsumableArray(new Set([].concat(_toConsumableArray(existing), _toConsumableArray(values)))),
                  expiresUnix: seconds ? Math.floor(Date.now()) + seconds * 1000 : undefined
                };
                return _context8.abrupt("return", this.store[key].value.length - lengthBefore);

              case 7:
                throw new Error('existing is not a set');

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "_setRemove",
    value: function _setRemove(key, values) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var existing, lengthBefore;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.parseEntryValue(key, this.store[key]);

              case 2:
                existing = _context9.sent;

                if (!Array.isArray(existing)) {
                  _context9.next = 9;
                  break;
                }

                lengthBefore = existing.length;
                this.store[key] = Object.assign(Object.assign({}, this.store[key]), {
                  value: existing.filter(function (e) {
                    return !values.some(function (v) {
                      return v === e;
                    });
                  })
                });
                return _context9.abrupt("return", this.store[key].value.length - lengthBefore);

              case 9:
                throw new Error('existing is not a set');

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "_setMembers",
    value: function _setMembers(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var existing;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.parseEntryValue(key, this.store[key]);

              case 2:
                existing = _context10.sent;

                if (!(existing === undefined || existing === null || Array.isArray(existing))) {
                  _context10.next = 7;
                  break;
                }

                return _context10.abrupt("return", existing || null);

              case 7:
                throw new Error('existing is not a set');

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "_setHas",
    value: function _setHas(key, value) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.setMembers(key);

              case 2:
                _context11.t2 = _a = _context11.sent;
                _context11.t1 = _context11.t2 === null;

                if (_context11.t1) {
                  _context11.next = 6;
                  break;
                }

                _context11.t1 = _a === void 0;

              case 6:
                if (!_context11.t1) {
                  _context11.next = 10;
                  break;
                }

                _context11.t3 = void 0;
                _context11.next = 11;
                break;

              case 10:
                _context11.t3 = _a.includes(value);

              case 11:
                _context11.t0 = _context11.t3;

                if (_context11.t0) {
                  _context11.next = 14;
                  break;
                }

                _context11.t0 = false;

              case 14:
                return _context11.abrupt("return", _context11.t0);

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }]);

  return MockCacheService;
}(CacheService_1.CacheService);

exports.MockCacheService = MockCacheService;